/**
 * 体験顧客のユニーク識別キーを返す。
 *
 * TrialCustomer モデルのフィールド確認済み（2025-04 時点）:
 *   - customer_id: モデルに存在しない → 使用不可
 *   - birth_date:  モデルに存在しない → 使用不可
 *   - id:          体験予約レコードID（予約ごとに別ID）→ ユニーク顧客判定に使わない
 *
 * 有効な優先順位:
 *   1. mail（空でない場合）
 *   2. phone_number（空でない場合）
 *   3. fallback: 予約ID（同一人物判定できないため別人扱いになる）
 *
 * fallback を使った場合は console.warn が出る。
 * 体験者数が実際より多くなる可能性があるので注意。
 */
export function getCustomerUniqueKey(customer) {
  // 1. メールアドレス
  const mail = (customer.mail || "").trim().toLowerCase();
  if (mail) return `mail:${mail}`;

  // 2. 電話番号
  const phone = (customer.phone_number || "").trim();
  if (phone) return `phone:${phone}`;

  // 3. fallback: 予約IDで別人扱い（体験者数が実際より多くなる可能性あり）
  console.warn(
    `[getCustomerUniqueKey] mail・phone 未設定のため予約IDをfallbackとして使用。` +
      ` booking_id=${customer.id} 体験者数が実際より多くなる可能性があります。`,
    { id: customer.id, last_name: customer.last_name, first_name: customer.first_name },
  );
  return `booking-id:${customer.id}`;
}

/**
 * 体験顧客リストをユニーク顧客リストに変換する。
 * 同一キーの場合は is_member=true のレコードを優先する。
 */
export function toUniqueCustomers(customers) {
  const map = {};
  for (const c of customers) {
    const key = getCustomerUniqueKey(c);
    if (!map[key] || (c.is_member && !map[key].is_member)) {
      map[key] = c;
    }
  }
  return Object.values(map);
}
